import React from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import loadingIndicatorStyles from './LoadingIndicator.module.scss';
import classNames from 'classnames/bind';

const LoadingIndicator = ({ show = null }) => {
  const { promiseInProgress } = usePromiseTracker();

  const boundStyles = classNames.bind(loadingIndicatorStyles);

  const wrapperStyles = boundStyles({
    wrapper: true,
    visible: promiseInProgress || show,
  });

  return (
    <div className={wrapperStyles}>
      {/* <Loader color="#33d176" type="ThreeDots" width={50} height={50} /> */}
    </div>
  );
};

export default LoadingIndicator;
